export default {"src":"/_next/static/image/public/assets/icons/upload.9bdd9e1618520da719dbefb6572627bb.svg","height":20,"width":20};